import React from 'react';
import { toIndianRs } from '../../../../../helpers';
import { giftSvg } from '../../../../../Routes/DealsAndDiscounts/Components/Header/svg';
import { isRewardsVisible } from '../../../../../utils/routing';

const FifthStep = ({
    userAccountSummary,
    getUserAccountSummary,
    setStep,
    setOpenKYCModal,
    closeKYCModal,
    initiateWorkflow,
    bankstatus
}) => {
    const outstandingAmount = userAccountSummary?.unInvoicedCommission;

    const tdsAmount = outstandingAmount * 0.1;

    const totalAmount = outstandingAmount - tdsAmount;

    const handleClick = () => {
        if(bankstatus === 'COMPLETED'){
             setStep(3);
        }
        else{
            initiateWorkflow('BANK_ACCOUNT_VERIFICATION');
        }
       
    };

    return (
        <>
            <div className="flex  flex-col items-center justify-center px-4 pt-6 pb-4 md:px-10 md:pt-6 md:pb-4">
                <div className=" border border-black w-64 md:w-96 lg:w-full">
                    <div className=" text-center font-bold py-2 border-b border-black text-base lg:text-lg">
                        Transfer to Bank Account
                    </div>

                    <div className="p-4 text-sm lg:text-base">
                        <div className="flex justify-between py-1 font-semibold">
                            <span>Referral Amount</span>
                            <span>{toIndianRs(outstandingAmount)}</span>
                        </div>
                        <div className="flex justify-between py-2 font-semibold">
                            <span>TDS @ 10%</span>
                            <span>{toIndianRs(tdsAmount)}</span>
                        </div>
                        <div className="flex justify-between border-t border-gray-100 py-1 mt-2 font-bold">
                            <span>TOTAL</span>
                            <span>{toIndianRs(totalAmount)}</span>
                        </div>
                    </div>
                </div>
                <div className="flex items-start justify-start">
                    <p className="text-sm text-gray-500 ml-2 lg:-ml-2 mt-2 ">
                        *TDS calculations are indicative as per Section 194J of
                        the Income Tax Act.
                    </p>
                </div>

                <div className=" pt-3 pb-2 lg:pt-3  lg:pb-3 xl:pt-4 xl:pb-4">
                    <button
                        onClick={handleClick}
                        className="bg-primary text-white rounded-md font-bold px-10  md:px-14 py-2 lg:py-3"
                    >
                        Continue
                    </button>
                </div>
                {isRewardsVisible && (
                    <div
                        onClick={closeKYCModal}
                        className="flex border-2 rounded-xl mt-4 cursor-pointer w-64 md:w-96 lg:w-full py-4 px-3 lg:px-4"
                    >
                        {giftSvg}
                        <div className="ml-2">
                            <h1 className="font-semibold">
                                Want to claim the whole amount?
                            </h1>
                            <p className="text-sm">
                                Redeem your reward at our exclusive store
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FifthStep;
